import type { ChannelAction, ChannelStatus, ChannelTypeKey } from '@/shared/api'
import { pick, serverMap } from '@/shared/lib/server-map'

export type ChannelActionStyle = ChannelAction['style']
export type ChannelActionKey = ChannelAction['key']

const TOKEN_FALLBACK = 'var(--ink-3)'

// Короткая подпись статуса и пояснение считаем на фронте: модель Channel их не несёт, приходит
// только enum. Тексты — из описаний в channel.yaml, сжато под пилюлю и вторую строку.
const STATUS_LABELS = serverMap({
  pending: 'Не завершено',
  active: 'Активен',
  needs_relogin: 'Нужен вход',
  token_invalid: 'Токен недействителен',
  banned: 'Заблокирован',
  degraded: 'С перебоями',
  disabled: 'Приостановлен',
})

const STATUS_HINTS = serverMap({
  pending: 'Подключение не завершено — продолжите или удалите',
  active: 'Подключён и работает',
  needs_relogin: 'Сессия разорвана — перепривяжите',
  token_invalid: 'Токен недействителен — смените',
  banned: 'Заблокирован мессенджером',
  degraded: 'Работает с перебоями',
  disabled: 'Остановлен вручную',
})

// Мнемо-подпись и цвет типа — декоративная палитра категорий (как stepGroupColor): различает
// аккаунты и ботов на карточке и плитке. Средней светлоты oklch, читается на светлой и тёмной.
const TYPE_LABELS = serverMap({
  max: 'MAX',
  vk: 'VK',
  tg: 'TG-бот',
  maxbot: 'MAX-бот',
  wa: 'WhatsApp',
})

const TYPE_TINTS = serverMap({
  max: 'oklch(60% 0.15 285)',
  vk: 'oklch(58% 0.14 255)',
  tg: 'oklch(62% 0.13 235)',
  maxbot: 'oklch(64% 0.13 200)',
  wa: 'oklch(62% 0.14 150)',
})

const STATUS_TOKENS = serverMap({
  pending: 'var(--st-pending)',
  active: 'var(--st-confirmed)',
  needs_relogin: 'var(--st-cancel)',
  token_invalid: 'var(--st-cancel)',
  banned: 'var(--st-cancel)',
  degraded: 'var(--st-pending)',
  disabled: 'var(--ink-3)',
})

const ACTION_TOKENS = serverMap({
  primary: 'var(--st-confirmed)',
  secondary: 'var(--ink-3)',
  danger: 'var(--st-cancel)',
})

const ACTION_CONFIRM = serverMap({
  disable: true,
  remove: true,
})

export function channelStatusToken(status: ChannelStatus): string {
  return pick(STATUS_TOKENS, status, TOKEN_FALLBACK)
}

export function channelActionToneToken(style: ChannelActionStyle): string {
  return pick(ACTION_TOKENS, style, TOKEN_FALLBACK)
}

export function channelActionNeedsConfirm(action: ChannelActionKey): boolean {
  return pick(ACTION_CONFIRM, action, false)
}

export function channelStatusLabel(status: ChannelStatus): string {
  return pick(STATUS_LABELS, status, status)
}

export function channelStatusHint(status: ChannelStatus): string {
  return pick(STATUS_HINTS, status, '')
}

export function channelTypeLabel(type: ChannelTypeKey): string {
  return pick(TYPE_LABELS, type, type)
}

export function channelTypeTint(type: ChannelTypeKey): string {
  return pick(TYPE_TINTS, type, TOKEN_FALLBACK)
}
